import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Eye, MessageCircle, MousePointerClick, Music2, ShoppingBag } from "lucide-react";
import { api, fileUrl, rupiah } from "../../lib/api";
import { usePolling } from "../../hooks/usePolling";
import { StatCard } from "../../components/StatCard";
import { ClicksChart } from "../../components/ClicksChart";
import { PhotoSlider } from "../../components/PhotoSlider";
import { Badge } from "../../components/ui/badge";

export default function ProductDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  usePolling(async () => {
    try {
      const { data } = await api.get(`/products/${id}`);
      setD(data);
    } catch (e) {
      setErr(true);
    }
  }, 5000, [id]);

  if (err && !d) return <p className="text-slate-500" data-testid="product-not-found">Produk tidak ditemukan.</p>;
  if (!d) return null;
  const p = d.product;
  const shopee = p.clicks_shopee || 0;
  const tiktok = p.clicks_tiktok || 0;
  const wa = p.clicks_whatsapp || 0;

  return (
    <div data-testid="product-detail-page">
      <Link to="/dashboard/products" data-testid="back-to-products" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 mb-6">
        <ArrowLeft className="h-4 w-4" />Kembali ke produk
      </Link>
      <div className="grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-2 space-y-3 fade-up">
          <div className="overflow-hidden rounded-2xl border border-slate-200">
            <PhotoSlider photos={p.photos} arrows testId="detail-photo-slider" />
          </div>
          <div className="grid grid-cols-5 gap-2">
            {p.photos.map((ph, i) => (
              <img key={ph + i} src={fileUrl(ph)} alt="" className="aspect-square w-full rounded-lg object-cover border border-slate-200" />
            ))}
          </div>
        </div>
        <div className="lg:col-span-3 space-y-6">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 fade-up">
            {p.category && <Badge variant="secondary">{p.category}</Badge>}
            <h1 className="mt-2 text-2xl font-extrabold tracking-tight" data-testid="product-detail-name">{p.name}</h1>
            <div className="mt-2 flex items-baseline gap-2">
              <span className="text-xl font-bold">{rupiah(p.price)}</span>
              {p.original_price > 0 && <span className="text-sm text-slate-400 line-through">{rupiah(p.original_price)}</span>}
            </div>
            {p.description && <p className="mt-3 text-sm text-slate-600 whitespace-pre-line">{p.description}</p>}
          </div>
          <div className="grid grid-cols-2 gap-4">
            <StatCard label="Total klik" value={shopee + tiktok + wa} icon={MousePointerClick} testId="detail-stat-total" />
            <div className="col-span-2 sm:col-span-1"><StatCard label="Dilihat" value={p.views} icon={Eye} testId="detail-stat-views" /></div>
            <StatCard label="Klik link Shopee" value={shopee} icon={ShoppingBag} accent="text-[#EE4D2D]" testId="detail-stat-shopee" />
            <StatCard label="Klik link TikTok" value={tiktok} icon={Music2} testId="detail-stat-tiktok" />
            <StatCard label="Klik WhatsApp" value={p.clicks_whatsapp} icon={MessageCircle} accent="text-[#25D366]" testId="detail-stat-whatsapp" />
          </div>
        </div>
      </div>
      <div className="mt-6"><ClicksChart data={d.daily} title="Klik harian produk ini" testId="product-clicks-chart" /></div>
    </div>
  );
}
